module.exports = __webpack_public_path__ + "img/login.1c286f9c.png";